<template>
  <div id="app" style="text-align: left;overflow-x: hidden;">
    <!--占位符-->
    <PcBar v-if="store.state.width >= 850"></PcBar>
    <PhoneBar v-if="store.state.width < 850"></PhoneBar>
    <router-view></router-view>
    <Footer v-if="store.state.width >= 850"></Footer>
    <PhoneFooter v-if="store.state.width < 850"></PhoneFooter>
  </div>
</template>

<script setup>
import {onMounted} from "vue";

let width = window.innerWidth
import PcBar from "@/components/navigation/PcBar"
import PhoneBar from "@/components/navigation/PhoneBar"
import Footer from "@/components/footer/PcFooter"
import PhoneFooter from "@/components/footer/PhoneFooter"
import {mixins} from "@/mixin/publicJs";
import store from "@/store";

const debounce = (fn, delay) => {
  let timer
  return (...args) => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 200);
    super(callback);
  }
}
const ProductType = () => {
  let data = {
    token: sessionStorage.token,
  }
  mixins.methods.axiosPost('/ProductType/getList', data, (res) => {
    let list = []
    for (let i of res.data.data) {
      let list2 = []
      for (let ii of i.list) {
        list2.push({
          name: ii.name,
          url: '/Products?Type=' + i.id + "&type=" + ii.id,
        })
      }
      list.push({
        name: i.name,
        title: i.id,
        url: '/Products?Type=' + i.id,
        list: list2
      })
    }
    store.commit("setNavigationBar", list)
  })

}
onMounted(() => {
  // ProductType()
  window.addEventListener("resize", () => {
    store.commit('setWidth', document.body.clientWidth)
  });
})
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

// IE浏览器
* {
  //三角箭头的颜色
  scrollbar-arrow-color: #c0c4cc;
  //滚动条滑块按钮的颜色*/
  scrollbar-face-color: #a2a2a3;
  //滚动条整体颜色*/
  scrollbar-highlight-color: #a2a2a3;
  //滚动条阴影*/
  scrollbar-shadow-color: #a2a2a3;
  //滚动条轨道颜色*/
  scrollbar-track-color: #f4f4f5;
  //滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色
  scrollbar-3dlight-color: #a2a2a3;
  //滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色
  scrollbar-darkshadow-color: #a2a2a3;
  //滚动条基准颜色
  scrollbar-base-color: #f4f4f5;
  scroll-padding-block: 6px;
}

// 谷歌浏览器
//  https://www.cnblogs.com/that-is-ok/p/10757282.html
//  https://www.jianshu.com/p/c2addb233acd
::-webkit-scrollbar {
  width: 10px;
  z-index: 20000;
}

/* Track */
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  /* box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;*/
}

/* Handle */
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 12px;
  //border: 1px solid rgba(255, 255, 255, 1);
  background: lightgray;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: darkgray;
}

// 如果想鼠标进入某个控件才显示滚动条的话，可以参考下面的代码写
// IE下隐藏
//.el-table__body-wrapper,
//.el-menu {
//  -ms-overflow-style: none;
//}

//.el-table__body-wrapper:hover,
//.el-menu:hover {
//  -ms-overflow-style: auto;
//}
// Chrome下隐藏
// .el-menu::-webkit-scrollbar,
// .el-table__body-wrapper::-webkit-scrollbar {
//   display: none;
// }
// .el-menu:hover::-webkit-scrollbar,
// .el-table__body-wrapper:hover::-webkit-scrollbar {
//   display: block;
// }

.bg-cover {
  background-repeat: no-repeat;
  background-position: center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%;
  z-index: 20000;

}

.ziColor .el-statistic__number {
  color: #f26228 !important;
  font-size: 40px;
}

.el-popper {
  z-index: 100000 !important;
  padding: 0px !important;
}

.el-collapse-item > button > i > svg {
  height: 0px;
}

.el-drawer__body {
  padding: 0px !important;
}
</style>
